<lib-list-page
    [host]="this"
    title="Schedules"
    icon="schedule"
    searchPlaceholder="Search name or task type…"
    [activeChips]="activeFilterChips()"
    (chipRemove)="removeFilterChip($event)"
    totalIcon="schedule"
    totalLabel="Schedules"
    emptyStateIcon="schedule"
    emptyStateTitle="No schedules match the current filter"
    emptyStateSubtitle="Create a schedule from the Task Catalog or with the New schedule button. Scheduled jobs show up here once they're saved.">

    <ng-container actions>
        <button mat-flat-button color="primary" *ngIf="canCreate()" (click)="createSchedule()">
            <mat-icon>add</mat-icon> New schedule
        </button>
        <button mat-icon-button (click)="refreshData(true)" matTooltip="Refresh" aria-label="Refresh">
            <mat-icon>refresh</mat-icon>
        </button>
    </ng-container>

    <ng-container filters>
        <div class="filter-select-box">
            <div class="filter-context-label">
                <mat-icon class="filter-context-icon">toggle_on</mat-icon>
                Status
                <span class="filter-active-count" *ngIf="filter().enabled !== 'ALL'">1</span>
            </div>
            <mat-form-field appearance="outline">
                <mat-select [value]="filter().enabled"
                            (selectionChange)="setEnabledFilter($event.value)">
                    <mat-option *ngFor="let opt of enabledOptions" [value]="opt.value">
                        {{ opt.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </ng-container>

    <table mat-table table [dataSource]="dataSource()" class="data-table" matSort (matSortChange)="sortData($event)">

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="name" class="nowrap">Name</th>
            <td mat-cell *matCellDef="let j" class="nowrap">
                <a class="schedule-name traversable" (click)="openDetail(j)">{{ j.name }}</a>
            </td>
        </ng-container>

        <ng-container matColumnDef="taskType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="taskType" class="nowrap">Task type</th>
            <td mat-cell *matCellDef="let j" class="nowrap">
                <span *ngIf="j.taskType" class="mono">{{ j.taskType }}</span>
                <span *ngIf="!j.taskType" class="muted">—</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="capabilityVersion">
            <th mat-header-cell *matHeaderCellDef class="nowrap">Version</th>
            <td mat-cell *matCellDef="let j" class="nowrap">
                <span *ngIf="j.capabilityVersion" class="mono muted-mono">{{ j.capabilityVersion }}</span>
                <span *ngIf="!j.capabilityVersion" class="muted">—</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="enabled">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="enabled" class="nowrap">Status</th>
            <td mat-cell *matCellDef="let j" class="nowrap">
                <span [class]="statusClass(j.enabled)">{{ j.enabled ? 'ENABLED' : 'DISABLED' }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="createTimestamp">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="createTimestamp" class="nowrap">Created</th>
            <td mat-cell *matCellDef="let j" class="nowrap">{{ j.createTimestamp | date:'medium' }}</td>
        </ng-container>

        <ng-container matColumnDef="actions" stickyEnd>
            <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
            <td mat-cell *matCellDef="let j" class="nowrap row-actions">
                <button mat-icon-button matTooltip="View" aria-label="View job" *ngIf="canView()" (click)="openDetail(j)">
                    <mat-icon>visibility</mat-icon>
                </button>
                <button mat-icon-button [matTooltip]="j.enabled ? 'Disable' : 'Enable'"
                        [attr.aria-label]="j.enabled ? 'Disable job' : 'Enable job'"
                        *ngIf="canUpdate()" (click)="toggleEnabled(j)">
                    <mat-icon>{{ j.enabled ? 'pause_circle' : 'play_circle' }}</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Delete" aria-label="Delete job" *ngIf="canDelete()" (click)="deleteSchedule(j)">
                    <mat-icon>delete_outline</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="selectable-table-row"></tr>
    </table>

</lib-list-page>
